/*!

=========================================================
* Purity UI Dashboard PRO - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/purity-ui-dashboard-pro
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design by Creative Tim & Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import { extendTheme } from '@chakra-ui/react';
import { globalStyles } from './styles';
import { font } from './foundations/fonts';
import { breakpoints } from './foundations/breakpoints';
import { buttonStyles } from './components/button';
import { badgeStyles } from './components/badge';
import { linkStyles } from './components/link';
import { drawerStyles } from './components/drawer';
import { CardComponent } from './additions/card/Card';
import { CardBodyComponent } from './additions/card/CardBody';
import { CardFooterComponent } from './additions/card/CardFooter';
import { CardHeaderComponent } from './additions/card/CardHeader';
import { MainPanelComponent } from './additions/layout/MainPanel';
import { PanelContentComponent } from './additions/layout/PanelContent';
import { PanelContainerComponent } from './additions/layout/PanelContainer';
// import { mode } from "@chakra-ui/theme-tools";
export default extendTheme(
	{
		colors: {
			health: {
				900: '#216D40',
				800: '#216D40',
				700: '#69C49D', // PRINCIPAL
				600: '#E5F7EC',
				500: '#FFD400'
			},
			complements: {
				green: '#305950',
				lightGreen: '#93BA1F',
				red: '#BB0034',
				yellow: '#BB0034',
				brown: '#815A2F',
				blue: '#455D9A',
				teal: '#25ABB9',
				purple: '#612774'
			},
			other: {
				marfin: '#F9EDD3',
				grey: '#5B5B5F',
				black: '#1A171B'
			}
		}
	},
	{ breakpoints }, // Breakpoints
	globalStyles,
	font, // Global styles
	buttonStyles, // Button styles
	badgeStyles, // Badge styles
	linkStyles, // Link styles
	drawerStyles, // Sidebar variant for Chakra's drawer
	CardComponent, // Card component
	CardBodyComponent, // Card Body component
	CardFooterComponent, // Card Footer component
	CardHeaderComponent, // Card Header component
	MainPanelComponent, // Main Panel component
	PanelContentComponent, // Panel Content component
	PanelContainerComponent // Panel Container component
);
